import { Ably } from "@pankod/refine-ably";
import { config } from "config";

export const ablyClient = new Ably.Realtime(config.ABLY_API_KEY || "");
